import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: "297ca9c4-91db-4c9f-90ad-87a157bf425b", // Replace with your Azure AD App's Client ID
    authority: "https://login.microsoftonline.com/f2ec7188-d455-4a3e-be2d-64b9b07533c2", // Replace with your Tenant ID
    redirectUri: window.location.origin.includes('localhost') ? "http://localhost:3000/" : window.location.origin, // Use dynamic redirect URI for tunnels
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) {
          console.log(message);
        }
      },
      logLevel: LogLevel.Error, // Only log errors
    },
  },
};

export const loginRequest = {
  scopes: [
    "499b84ac-1321-427f-aa17-267ca6975798/.default" // Azure DevOps scope for accessing resources
  ],
  authority: "https://login.microsoftonline.com/organizations", // Use organizations authority for Azure DevOps
};
